/* eslint-disable import/prefer-default-export */
import moment from "moment";
import { all, takeLatest, call, put, delay } from "redux-saga/effects";
import { generateCalenderPayload } from "../../../Container/Schedule/helper";
import API, { responseParser } from "../../services/api";
import {
  FETCH_SCHEDULE,
  SET_SCHEDULE,
  RUN_SCHEDULE,
  LAST_WATERED,
  SET_LAST_WATERED,
  SET_UPCOMING_WATERED,
  GET_CALENDAR_DATES,
  SET_CALENDAR_DATES,
  GET_SCHEDULE_FOR_DAY,
  SET_SCHEDULE_FOR_DAY,
  GET_CURRENT_WATERING,
  SET_CURRENT_WATERING,
  MODIFY_SCHEDULE,
  STOP_SCHEDULE_LOADER,
  NEW_SCHEDULE,
  DELETE_SCHEDULE,
  STOP_WATERING,
  SKIP_WATERING,
} from "./types";

function* getSchedule({ payload }) {
  const response = yield call(api.getAllSchedules, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_SCHEDULE, payload: result });
  }
}

function* runSchedule({ payload }) {
  const response = yield call(api.runSchedule, payload);
  responseParser(
    response,
    "Error while running schedule",
    "Manual Watering Started"
  );
}

function* lastWatered({ payload }) {
  const response = yield call(api.lastWatered, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_LAST_WATERED, payload: result });
    yield call(upcomingWatering, payload);
  }
}

function* upcomingWatering(payload) {
  const response = yield call(api.upcomingWatering, payload);
  const result = responseParser(response, "", "", false);
  if (result) {
    yield put({ type: SET_UPCOMING_WATERED, payload: result });
  }
}

function* getDates({ payload }) {
  const response = yield call(api.fetchCalendarDates, payload);
  const result = responseParser(response);
  if (result) {
    let calendar = {};
    result.forEach((item) => {
      const date = moment(item).format("YYYY-MM-DD");
      if (calendar[date]) {
        calendar = {
          ...calendar,
          [date]: {
            ...calendar[date],
            count: calendar[date].count + 1,
          },
        };
      } else {
        calendar = {
          ...calendar,
          [date]: {
            timestamp: item,
            count: 1,
          },
        };
      }
    });
    yield put({ type: SET_CALENDAR_DATES, payload: calendar });
  }
}

function* getScheduleForDay({ payload }) {
  const response = yield call(api.fetchScheduleForDay, payload);
  const result = responseParser(response, "Error while fetching schedules");
  if (result) {
    yield put({ type: SET_SCHEDULE_FOR_DAY, payload: result });
  }
}

function* getCurrentWatering({ payload }) {
  const response = yield call(api.currentWatering, payload);
  const result = responseParser(response);
  if (result) {
    yield put({ type: SET_CURRENT_WATERING, payload: result });
  }
}

function* createSchedule({ payload }) {
  const response = yield call(api.createSchedule, payload.schedule);
  const result = responseParser(response, "Error", null, true, true);
  if (result) {
    yield call(getSchedule, { payload: { deviceId: payload.device._id } });
    yield delay(1000);
    const wateringInfo = yield call(generateCalenderPayload);
    const calenderResponse = yield call(api.createCalender, wateringInfo);
    const calenderResult = responseParser(
      calenderResponse,
      "Error",
      null,
      true,
      true
    );
    if (calenderResult) {
      yield put({ type: STOP_SCHEDULE_LOADER });
    }
  } else {
    yield put({ type: STOP_SCHEDULE_LOADER });
  }
}

function* modifySchedule({ payload }) {
  const response = yield call(api.updateSchedule, payload.schedule);
  const result = responseParser(response, "Error", null, true, true);
  if (result) {
    yield call(getSchedule, { payload: { deviceId: payload.device._id } });
    yield delay(1000);
    const wateringInfo = yield call(generateCalenderPayload);
    const calenderResponse = yield call(api.createCalender, wateringInfo);
    const calenderResult = responseParser(
      calenderResponse,
      "Error",
      null,
      true,
      true
    );
    if (calenderResult) {
      yield put({ type: STOP_SCHEDULE_LOADER });
    }
  } else {
    yield put({ type: STOP_SCHEDULE_LOADER });
  }
}

function* deleteSchedule({ payload }) {
  console.log(payload);
  const response = yield call(api.deleteSchedule, { _id: payload._id });
  const result = responseParser(response, "Error", null, true, true);
  if (result) {
    yield call(getSchedule, { payload: { deviceId: payload.deviceId } });
    yield delay(1000);
    const wateringInfo = yield call(generateCalenderPayload);
    const calenderResponse = yield call(api.createCalender, wateringInfo);
    const calenderResult = responseParser(
      calenderResponse,
      "Error",
      null,
      true,
      true
    );
    if (calenderResult) {
      yield put({ type: STOP_SCHEDULE_LOADER });
    }
  }
}

function* stopWatering({ payload }) {
  const response = yield call(api.stopWatering, payload);
  responseParser(response, "Error", "", true, true);
}

function* skipWatering({ payload }) {
  const response = yield call(api.skipWatering, payload);
  responseParser(response, "Error", "", true, true);
}

const api = API.create();
export function* combinedSagas() {
  yield all([
    yield takeLatest(FETCH_SCHEDULE, getSchedule),
    yield takeLatest(RUN_SCHEDULE, runSchedule),
    yield takeLatest(LAST_WATERED, lastWatered),
    yield takeLatest(GET_CALENDAR_DATES, getDates),
    yield takeLatest(GET_SCHEDULE_FOR_DAY, getScheduleForDay),
    yield takeLatest(GET_CURRENT_WATERING, getCurrentWatering),
    yield takeLatest(MODIFY_SCHEDULE, modifySchedule),
    yield takeLatest(NEW_SCHEDULE, createSchedule),
    yield takeLatest(DELETE_SCHEDULE, deleteSchedule),
    yield takeLatest(STOP_WATERING, stopWatering),
    yield takeLatest(SKIP_WATERING, skipWatering),
  ]);
}
